import { styled } from '@mui/material/styles';
import { collapsedWidthFactor, navigationWidthFactor } from '../../../themes/sovos-sizes';
import { productSwitcherClasses } from '../../../sovos-product-menu/SovosProductMenu';
export const Root = styled('nav', {
  shouldForwardProp: prop => prop !== 'shouldShowProductSwitcher'
})(_ref => {
  var _components$SovosNavi, _components$SovosNavi2, _components$SovosNavi3, _components$SovosNavi4, _components$SovosNavi5;
  let {
    shouldShowProductSwitcher,
    theme: {
      components,
      palette,
      spacing,
      transitions
    }
  } = _ref;
  const navigationWidth = spacing(navigationWidthFactor);
  const collapsedWidth = spacing(collapsedWidthFactor);
  const collapsedSwitcherWidth = spacing(collapsedWidthFactor - 2);
  return {
    background: "linear-gradient(".concat((_components$SovosNavi = components === null || components === void 0 || (_components$SovosNavi2 = components.SovosNavigation) === null || _components$SovosNavi2 === void 0 || (_components$SovosNavi2 = _components$SovosNavi2.styleOverrides) === null || _components$SovosNavi2 === void 0 ? void 0 : _components$SovosNavi2.gradientTop) !== null && _components$SovosNavi !== void 0 ? _components$SovosNavi : palette.primary.dark, ", ").concat((_components$SovosNavi3 = components === null || components === void 0 || (_components$SovosNavi4 = components.SovosNavigation) === null || _components$SovosNavi4 === void 0 || (_components$SovosNavi4 = _components$SovosNavi4.styleOverrides) === null || _components$SovosNavi4 === void 0 ? void 0 : _components$SovosNavi4.gradientBottom) !== null && _components$SovosNavi3 !== void 0 ? _components$SovosNavi3 : palette.primary.dark, ")"),
    flex: "0 0 ".concat(navigationWidth),
    height: '100vh',
    outline: 'none',
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: "flex ".concat(transitions.duration.enteringScreen, "ms"),
    width: navigationWidth,
    // parent switches from flex-direction: row to column

    '&.sovosNavigation--minimal': {
      flex: "0 0 ".concat(collapsedWidth),
      width: collapsedWidth
    },
    '&.sovosNavigation--minimal .sovosNavigation__content': {
      transition: "width ".concat(transitions.duration.enteringScreen, "ms"),
      width: collapsedWidth
    },
    '&.sovosNavigation--minimal .sovosAccountSwitcher': {
      marginBlockStart: shouldShowProductSwitcher ? spacing(2) : 0
    },
    '&:not(.sovosNavigation--minimal) .sovosProductMenu': {
      marginInlineEnd: spacing(1)
    },
    '& .SovosAccountSwitcher__buttonContents:not(.SovosAccountSwitcher__buttonContents--minimized)': {
      borderLeft: 'none',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginBlockStart: spacing(2),
      marginInlineEnd: spacing()
    },
    '&.sovosNavigation--minimal .sovosAccountSwitcher__button': {
      margin: "0 ".concat(spacing()),
      minWidth: collapsedSwitcherWidth,
      width: collapsedSwitcherWidth
    },
    ["& .".concat(productSwitcherClasses.buttonContents)]: {
      background: components === null || components === void 0 || (_components$SovosNavi5 = components.SovosNavigation) === null || _components$SovosNavi5 === void 0 || (_components$SovosNavi5 = _components$SovosNavi5.styleOverrides) === null || _components$SovosNavi5 === void 0 ? void 0 : _components$SovosNavi5.productIconColor
    }
  };
});
export const NavHeader = styled('header')(_ref2 => {
  let {
    theme: {
      spacing
    }
  } = _ref2;
  return {
    padding: "".concat(spacing(3), " 0 ").concat(spacing(2), " 0")
  };
});
export const LogoAndProductContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'shouldShowProductName'
})(_ref3 => {
  let {
    shouldShowProductName
  } = _ref3;
  return {
    alignItems: shouldShowProductName ? 'start' : 'center',
    display: 'flex',
    justifyContent: 'center'
  };
});
export const LogoAndProduct = styled('div')(_ref4 => {
  let {
    theme: {
      spacing
    }
  } = _ref4;
  return {
    display: 'inline-flex',
    flex: "1 0 ".concat(spacing(navigationWidthFactor - 8.5)),
    flexDirection: 'column',
    gap: 6,
    paddingInlineStart: spacing(2.5),
    paddingInlineEnd: spacing()
  };
});
export const LinksContainer = styled('div')(_ref5 => {
  let {
    theme: {
      spacing
    }
  } = _ref5;
  return {
    flex: 'auto',
    paddingBlockStart: spacing(),
    overflowX: 'hidden',
    overflowY: 'auto'
  };
});
export const NavContent = styled('div')(_ref6 => {
  let {
    theme: {
      spacing,
      transitions
    }
  } = _ref6;
  const navigationWidth = spacing(navigationWidthFactor);
  return {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    transition: "width ".concat(transitions.duration.leavingScreen, "ms"),
    width: navigationWidth
  };
});
export const ProductName = styled('div', {
  shouldForwardProp: prop => prop !== 'productName'
})(_ref7 => {
  var _components$SovosNavi6, _components$SovosNavi7;
  let {
    productName,
    theme: {
      components,
      palette,
      typography
    }
  } = _ref7;
  return {
    ...typography.h3,
    color: (_components$SovosNavi6 = components === null || components === void 0 || (_components$SovosNavi7 = components.SovosNavigation) === null || _components$SovosNavi7 === void 0 || (_components$SovosNavi7 = _components$SovosNavi7.styleOverrides) === null || _components$SovosNavi7 === void 0 ? void 0 : _components$SovosNavi7.textColor) !== null && _components$SovosNavi6 !== void 0 ? _components$SovosNavi6 : palette.primary.contrastText,
    fontSize: (productName === null || productName === void 0 ? void 0 : productName.length) <= 6 ? typography.h3.fontSize : '1.375rem',
    lineHeight: '1.75rem'
  };
});
export const ProductLogo = styled('img', {
  shouldForwardProp: prop => prop !== 'productName'
})(_ref8 => {
  let {
    productName,
    theme: {
      spacing
    }
  } = _ref8;
  return {
    height: productName ? spacing(1.75) : spacing(3),
    opacity: 0.8,
    paddingInlineEnd: spacing(),
    width: productName ? spacing(8.5) : spacing(15)
  };
});